import type { ResumesState, ResumesAction } from './types'

const initialState: ResumesState = {
  byId: {},
  allIds: [],
  currentResumeId: null,
  status: {
    loading: false,
    error: null,
  },
}

function resumesReducer(
  state: ResumesState = initialState,
  action: ResumesAction,
): ResumesState {
  switch (action.type) {
    case 'CREATE_RESUME': {
      const { id } = action.payload
      return {
        ...state,
        byId: {
          ...state.byId,
          [id]: action.payload,
        },
        allIds: [...state.allIds, id],
        currentResumeId: id,
      }
    }

    case 'UPDATE_RESUME': {
      const { id, updates } = action.payload
      if (!state.byId[id]) {
        return state
      }
      return {
        ...state,
        byId: {
          ...state.byId,
          [id]: {
            ...state.byId[id],
            ...updates,
            updatedAt: new Date().toISOString(),
          },
        },
      }
    }

    case 'DELETE_RESUME': {
      const id = action.payload
      const { [id]: deleted, ...restById } = state.byId
      const allIds = state.allIds.filter((resumeId) => resumeId !== id)

      let newCurrentResumeId = state.currentResumeId
      if (state.currentResumeId === id) {
        newCurrentResumeId = allIds.length > 0 ? allIds[0] : null
      }

      return {
        ...state,
        byId: restById,
        allIds,
        currentResumeId: newCurrentResumeId,
      }
    }

    case 'SET_CURRENT_RESUME': {
      return {
        ...state,
        currentResumeId: action.payload,
      }
    }

    case 'SET_RESUMES_LOADING': {
      return {
        ...state,
        status: {
          ...state.status,
          loading: action.payload,
        },
      }
    }

    case 'SET_RESUMES_ERROR': {
      return {
        ...state,
        status: {
          ...state.status,
          error: action.payload,
        },
      }
    }

    case 'SET_ALL_RESUMES': {
      return {
        ...state,
        byId: action.payload.byId,
        allIds: action.payload.allIds,
      }
    }

    case 'UPDATE_RESUME_ID': {
      const { oldId, newId } = action.payload

      // If the resume doesn't exist (already been replaced), just return the state
      if (!state.byId[oldId]) {
        return state
      }

      // Create new byId with the updated ID
      const { [oldId]: resumeToUpdate, ...restById } = state.byId

      // Replace current resume ID if needed
      const newCurrentResumeId =
        state.currentResumeId === oldId ? newId : state.currentResumeId

      // Update allIds array
      const allIds = state.allIds.map((id) => (id === oldId ? newId : id))

      return {
        ...state,
        byId: {
          ...restById,
          [newId]: {
            ...resumeToUpdate,
            id: newId,
          },
        },
        allIds,
        currentResumeId: newCurrentResumeId,
      }
    }

    default:
      return state
  }
}

export { resumesReducer as default, initialState }
